import React from 'react'
import PropTypes from 'prop-types'
import styled from '@emotion/styled'

const IconAll = ({ className }) => {
  return (
    <svg
      width='85'
      height='85'
      viewBox='0 0 85 85'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M42.5 85C65.9721 85 85 65.9721 85 42.5C85 19.0279 65.9721 0 42.5 0C19.0279 0 0 19.0279 0 42.5C0 65.9721 19.0279 85 42.5 85Z'
        fill='white'
      />
      <path
        d='M23.6001 25.7C23.6001 26.5307 23.8464 27.3427 24.3079 28.0334C24.7694 28.7241 25.4254 29.2624 26.1928 29.5803C26.9603 29.8982 27.8048 29.9814 28.6195 29.8193C29.4342 29.6572 30.1826 29.2572 30.7699 28.6698C31.3573 28.0825 31.7573 27.3341 31.9194 26.5194C32.0815 25.7047 31.9983 24.8602 31.6804 24.0927C31.3625 23.3253 30.8242 22.6693 30.1335 22.2078C29.4428 21.7463 28.6308 21.5 27.8001 21.5C26.6934 21.523 25.6384 21.9729 24.8557 22.7556C24.073 23.5383 23.6231 24.5933 23.6001 25.7Z'
        fill='#D8D8D8'
        stroke='#5A5654'
        strokeWidth='1.5'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M25.6999 33.1C21.4999 33.1 19.3999 37 19.3999 41.9V47.8H23.5999L25.6999 61.4H29.8999L30.8999 55.1'
        fill='#D8D8D8'
      />
      <path
        d='M25.6999 33.1C21.4999 33.1 19.3999 37 19.3999 41.9V47.8H23.5999L25.6999 61.4H29.8999L30.8999 55.1'
        stroke='#5A5654'
        strokeWidth='1.5'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M42.4998 27.8C44.8194 27.8 46.6998 25.9196 46.6998 23.6C46.6998 21.2804 44.8194 19.4 42.4998 19.4C40.1802 19.4 38.2998 21.2804 38.2998 23.6C38.2998 25.9196 40.1802 27.8 42.4998 27.8Z'
        fill='#FFD356'
        stroke='#5A5654'
        strokeWidth='1.5'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M46.7001 48.8L44.6001 65.6H40.4001L38.3001 48.8H34.1001V40.4C34.1001 38.1722 34.9851 36.0356 36.5604 34.4603C38.1357 32.885 40.2723 32 42.5001 32C44.7279 32 46.8645 32.885 48.4398 34.4603C50.0151 36.0356 50.9001 38.1722 50.9001 40.4V48.8H46.7001Z'
        fill='#FFD356'
        stroke='#5A5654'
        strokeWidth='1.5'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M61.4 25.7C61.4 26.5307 61.1537 27.3427 60.6922 28.0334C60.2307 28.7241 59.5747 29.2624 58.8073 29.5803C58.0398 29.8982 57.1953 29.9814 56.3806 29.8193C55.5659 29.6572 54.8175 29.2572 54.2302 28.6698C53.6428 28.0825 53.2428 27.3341 53.0807 26.5194C52.9186 25.7047 53.0018 24.8602 53.3197 24.0927C53.6376 23.3253 54.1759 22.6693 54.8666 22.2078C55.5573 21.7463 56.3693 21.5 57.2 21.5C58.3067 21.523 59.3617 21.9729 60.1444 22.7556C60.9271 23.5383 61.377 24.5933 61.4 25.7Z'
        fill='#D8D8D8'
        stroke='#5A5654'
        strokeWidth='1.5'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M59.3001 33.1C63.5001 33.1 65.6001 37 65.6001 41.9V47.8H61.4001L59.3001 61.4H55.1001L54.1001 55.1'
        fill='#D8D8D8'
      />
      <path
        d='M59.3001 33.1C63.5001 33.1 65.6001 37 65.6001 41.9V47.8H61.4001L59.3001 61.4H55.1001L54.1001 55.1'
        stroke='#5A5654'
        strokeWidth='1.5'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    </svg>
  )
}

IconAll.propTypes = {
  className: PropTypes.string
}

const StyledIconAll = styled(IconAll)`
  height: 150px;
`

export default StyledIconAll
